import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import CouponBanner from '../../components/CouponBanner/CouponBanner';

export const RESCUE_BANNER_COOKIE = 'rescue_banner_data';

interface RescueBannerData {
  orgName: string | null;
  offer: string;
}

export function showRescueGwaVariant(): boolean {
  return !!Cookies.get(RESCUE_BANNER_COOKIE);
}

/**
 * Reads rescue banner data from a cookie set by the /rescue/:slug landing route.
 * Renders a persistent banner on the shop page showing the rescue partnership offer.
 * Re-checks the cookie on every navigation so it picks up the value after redirect.
 */
export default function RescueBanner() {
  const location = useLocation();
  const [bannerData, setBannerData] = useState<RescueBannerData | null>(null);

  useEffect(() => {
    const raw = Cookies.get(RESCUE_BANNER_COOKIE);
    if (raw) {
      try {
        setBannerData(JSON.parse(raw));
      } catch {
        // ignore malformed cookie
      }
    }
  }, [location.pathname]);

  const dismiss = () => {
    Cookies.remove(RESCUE_BANNER_COOKIE, { path: '/' });
    setBannerData(null);
  };

  if (!bannerData) {
    return null;
  }

  const name = bannerData.orgName ?? 'Your rescue';
  const text = `${name} has partnered with Fi — enter your promo code at checkout for ${bannerData.offer}`;

  return <CouponBanner bannerText={text} onDismiss={dismiss} variant="rescueGreen" />;
}
